import styled from "styled-components";

const DEFAULT_SIZE = "8px";

export const Bullet = styled.span<{ color: string; size?: string }>`
    display: inline-block;
    align-self: center;
    ${({ size = DEFAULT_SIZE }) => `
        width: ${size};
        height: ${size};
        `};
    border-radius: 8px;
    ${({ color }) => `background:${color}`}
`;
